let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5UGXq")).then(() => parcelRequire('37KJV'));